import { api } from '@/shared/api/axios';
import type { LoginCredentials, LoginResponse } from '@/shared/types/auth';
import type { CurrentUser } from '@/shared/types/index';

/**
 * Thin wrapper over the EXISTING auth endpoints. No refresh/forgot/remember —
 * those don't exist on the backend (see docs/architecture/authentication.md).
 */
export const authService = {
  login(credentials: LoginCredentials) {
    return api.post<LoginResponse>('/api/auth/login', credentials).then((r) => r.data);
  },
  logout() {
    return api.post('/api/auth/logout').then((r) => r.data);
  },
  /** Session restore + permission load. 401 here = no/invalid session. */
  me() {
    return api.get<CurrentUser>('/api/auth/me').then((r) => r.data);
  },
  changePassword(currentPassword: string, newPassword: string) {
    return api
      .post('/api/auth/change-password', { currentPassword, newPassword })
      .then((r) => r.data);
  },
};
